<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                        'bg-gray-600': sharedService.userTheme === 'dark',
                        'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row padding10">
        <h5>Print Lab Licenses</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-col">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-700': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <ol>
          <li>Enter comma separated state numbers and or ranges. e.g. 6000-6500, 7050, 7058, 7100-7200</li>
          <li>If you would like to return all labs of a specific type leave the state number field empty.</li>
          <li>Select the type of renewal you would like to generate.</li>
          <li>Click the <strong>Generate Renewal Form(s)</strong> button.</li>
        </ol>
        <br />
        <span *ngIf="type == 'HST'">Currently filtering to certificate type <strong>T - HST</strong> and lab
          type <strong>10 - Health Fair/Health Screen Testing</strong> </span>
        <span *ngIf="type == 'SOA'">Currently filtering to certificate type <strong>R - Registration</strong>
          and lab type <strong>30 - SOA Registry</strong> </span>
      </mat-card-content>
    </mat-card>
    <form [formGroup]="formGroup">
      <div class="flex flex-row">

        <mat-form-field Style="padding-right:20px">
          <mat-label>Enter State Numbers (optional)</mat-label>
          <textarea matInput cdkTextareaAutosize formControlName="StateNumbers"></textarea>
          <mat-error *ngIf="formGroup.get('StateNumbers').invalid">
            Cannot be longer than 4000 characters.
          </mat-error>
        </mat-form-field>

        <mat-form-field Style="padding-right:20px">
          <mat-label>Lab Type</mat-label>
          <mat-select formControlName="LicenseType" (selectionChange)="typeChange()">
            <mat-option value=""></mat-option>
            <mat-option value="HST">HST</mat-option>
            <mat-option value="SOA">SOA</mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('LicenseType').invalid">
            Required field.
          </mat-error>
        </mat-form-field>

        <div>
          <button type="button" mat-raised-button color="primary" (click)="print()">Generate Renewal Form(s)</button>
        </div>

      </div>
    </form>
    <div class="flex flex-col">
      <span>
        <small>State #'s may be entered as a range separated by a dash and/or individual State #s separated by
          commas</small>
        <br />
        Example: 101-302,9756,9800-9900,10001
      </span>
    </div>
  </div>

</div>